"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ const defaultTranslations = exports.defaultTranslations = {
    articleFeedbackNo: 'No, I still need help',
    articleFeedbackTitle: 'Did this answer your question?',
    articleFeedbackYes: 'Yes, it did',
    contactUs: 'Contact Us',
    contentMissing: 'Content is inaccurate or missing',
    contentNotRelevant: 'It was not relevant to the search results',
    emptyCategoryDescription: 'No articles or subcategories here yet. Select a different category or use the search bar.',
    emptyCategoryTitle: 'This category is empty',
    hiHowCanWeHelp: 'Hi, how can we help?',
    hide: 'Hide',
    home: 'Home',
    howCanWeImproveThisArticle: 'How can we improve this article? (Optional)',
    loading: 'Loading',
    logIn: 'Sign in',
    mostCommonQuestions: 'Most common questions',
    nResultsForQuery: "{count} results for ''{query}''",
    needMoreHelp: 'Need more help?',
    search: 'Search',
    searchInSupportCenter: 'Search in support center',
    showMore: 'Show More',
    somethingWentWrong: 'Something went wrong. Please try again later.',
    submit: 'Submit',
    supportCenter: 'SupportCenter',
    whatWasTheIssue: 'What was the issue with this article?',
    youCanContactBrandPartner: 'You can always contact your sponsor for further assistance.'
};
const translationsNamespace = exports.translationsNamespace = 'support-center';
